import classNames from 'classnames';
import { IGlossaryItem, ISectionProps } from './glossary.js';
import { GlossarySectionList } from './glossary-section-list.js';

const colculateHalfItems = (items: IGlossaryItem[]) => {
  const itemsArray = items.map((item) => (item.children?.length ?? 0) + 1); // 1 is header
  const total = itemsArray.reduce((partialSum, a) => partialSum + a, 0);
  const needle = total / 2;
  const result = itemsArray.reduce<{ index?: number; sum: number }>(
    (partialSum, a, index) => {
      const sum = partialSum.sum + a;
      if (sum <= needle) {
        return { sum, index };
      }
      return { sum, index: partialSum.index };
    },
    {
      index: undefined,
      sum: 0,
    },
  );

  if (result.index === undefined) {
    return Math.ceil(items.length / 2);
  }

  return result.index + 1;
};

export const GlossarySection = ({ classes, title, items }: ISectionProps) => {
  const half = colculateHalfItems(items);
  const firstHalfItems = items.slice(0, half);
  const secondHalfItems = items.slice(half);
  return (
    <>
      <div className="Tile-body-header u-sm-hidden Section-header">
        <h3>{title}</h3>
      </div>
      <div className={classNames('Glossary Section-list col-gutter-negative', classes)}>
        <GlossarySectionList items={firstHalfItems} classes="first" />
        <GlossarySectionList items={secondHalfItems} />
      </div>
    </>
  );
};
